export default __webpack_public_path__ + "static/media/CarInsurance.1ea9188f.webp";